import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-localstorage',
	templateUrl:'./LocalStoragePluginPage.html',
	styles: [],
	styleUrls:['./LocalStoragePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class LocalStoragePluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_617 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>localstorage</artifactId>
</dependency>
\`\`\``;
	mdContent_618 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:localstorage:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_619 = `\`\`\`java
@Inject
@Named("localstorage")
private UUID deviceId;

// Use deviceId to identify the browser/device
\`\`\``;
	mdContent_620 = `\`\`\`java
// Inject the device identifier anywhere in call scope
@Inject
@Named("localstorage")
private UUID deviceId;
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
